var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_2513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 7.33301H11.5333C11.5333 7.82968 11.43 8.28968 11.2433 8.69968L12.0633 9.51968C12.4433 8.86968 12.6667 8.12634 12.6667 7.33301ZM9.99 7.44301C9.99 7.40634 10 7.36968 10 7.33301V3.33301C10 2.22634 9.10333 1.33301 8 1.33301C6.89667 1.33301 6 2.22634 6 3.33301V3.45634L9.99 7.44301ZM2.85 1.99967L2 2.84967L6.00667 6.85634V7.33634C6.00667 8.43968 6.89667 9.33634 8 9.33634C8.15 9.33634 8.29333 9.31634 8.43333 9.28634L9.54 10.393C9.06333 10.613 8.54 10.7363 8 10.7363C6.16 10.7363 4.46667 9.33634 4.46667 7.33634H3.33333C3.33333 9.61301 5.14667 11.493 7.33333 11.8163V13.9997H8.66667V11.813C9.27 11.723 9.84333 11.513 10.36 11.2097L13.15 13.9997L14 13.153L2.85 1.99967Z",
    fill: "#282D38"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_2513"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic_off.08820bfab4879b78d5ff87400e691464.svg";
export { ForwardRef as ReactComponent };